<template>
  <Card class="layout-card" style="height: 100%">
    <Tabs v-model="activeTab" @on-click="handleTabChange">
      <TabPane v-for="tab in tabs" :key="tab.value" :label="tab.label" :name="tab.value" />
    </Tabs>

    <Row :gutter="10" style="margin-top: 10px">
      <Col>
      <Button type="primary" icon="md-add" @click="handleAdd">新增剧场配置</Button>
      <Button type="success" icon="ios-paper-plane" @click="handleSaveOrder" style="margin-left: 10px"
        :disabled="!isDataChanged && !isUpdate">发布</Button>
      </Col>
    </Row>

    <div class="table-container" style="margin-top: 10px">
      <div v-if="loading" class="loading-overlay">
        <div class="loading-spinner"></div>
      </div>
      <table class="custom-table">
        <thead>
          <tr>
            <th class="col-drag"></th>
            <th class="col-title">标题</th>
            <th class="col-subtitle">副标题</th>
            <th class="col-style">样式</th>
            <th class="col-count">剧集数量</th>
            <th class="col-enabled">启用</th>
            <th class="col-action">操作</th>
          </tr>
        </thead>
        <draggable :value="tableData" tag="tbody" :handle="'.drag-icon'" item-key="id" animation="200"
          ghost-class="sortable-ghost" @end="handleDragEnd"  @input="tableData = $event">
          <tr :key="element.id" v-for="element in tableData">
            <td class="col-drag">
              <Icon v-if="element.style === 2||element.state === 0" type="ios-lock" style="font-size: 18px; color: #999" />
              <Icon v-else type="ios-menu" class="drag-icon" style="cursor: move; font-size: 18px; color: #999" />
            </td>
            <td class="col-title" :title="element.title">{{ element.title }}</td>
            <td class="col-subtitle" :title="element.subhead">{{ element.subhead }}</td>
            <td class="col-style">
              <span :style="{
                display: 'inline-block',
                padding: '3px 8px',
                borderRadius: '50px',
                fontSize: '12px',
                backgroundColor: element.style === 2 ? '#fff3cd' : '#e3f2fd',
                color: element.style === 2 ? '#856404' : '#1976d2'
              }">
                {{ element.style === 2 ? '三列瀑布流(置底)' : '单行剧集卡片' }}
              </span>
            </td>
            <td class="col-count">{{ element.playSum }}</td>
            <td class="col-enabled">
              <i-switch :value="element.state === 1" @on-change="val => handleSwitchChange(element, val)" />
            </td>
            <td class="col-action">
              <a style="color: #2d8cf0; margin-right: 10px" @click="handleEdit(element)">编辑</a>
              <a style="color: #2d8cf0; margin-right: 10px" @click="handleModifyList(element)">修改剧集列表</a>
              <a style="color: #ed4014" @click="handleDelete(element)">删除</a>
            </td>
          </tr>
        </draggable>
        <tr v-if="tableData.length === 0" class="no-data">
          <td colspan="7" style="text-align: center; padding: 20px 0;">
            暂无数据
          </td>
        </tr>
      </table>
    </div>

    <Pages :page="page" :func="getData" style="margin-top: 10px" />

    <Modal :title="isEdit ? '编辑剧场配置: ' + formData.title : '新增剧场配置'" v-model="dialogVisible" width="500px">
      <Form :label-width="80" :model="formData" ref="formRef" :rules="formRules">
        <FormItem label="标题" prop="title">
          <Input v-model="formData.title" placeholder="请输入标题" />
        </FormItem>
        <FormItem label="副标题" prop="subhead">
          <Input v-model="formData.subhead" type="textarea" :rows="3" placeholder="请输入副标题" />
        </FormItem>
        <FormItem label="样式" prop="style">
          <Select v-model="formData.style" placeholder="请选择样式">
            <Option v-for="style in styleOptions" :key="style.value" :label="style.label" :value="style.value" />
          </Select>
        </FormItem>
      </Form>
      <template #footer>
        <Button @click="handleCancel">取消</Button>
        <Button type="primary" @click="handleSave">保存</Button>
      </template>
    </Modal>

    <EpisodeListDialog :visible="episodeDialogVisible" :langId="activeTab" :theater-name="selectedTheater ? selectedTheater.title : ''"
      :id="selectedTheater ? selectedTheater.id : ''" :isUpdate.sync="isUpdate" @update:visible="episodeDialogVisible = $event"
      @confirm="handleConfirm"
     />
  </Card>
</template>

<script>
import draggable from 'vuedraggable'
import Pages from '@/components/pages'
import EpisodeListDialog from './episode-list-dialog.vue'
import { getLangList } from '../../api/lang'
import { getConfigList, addConfig, deleteConfig, publishConfig, updateSort, updateConfig } from '@/api/theater-list'
export default {
  name: 'TheaterList',
  components: {
    draggable,
    Pages,
    EpisodeListDialog
  },
  data() {
    return {
      isUpdate:false,
      isFirstLoad: true,  // 标记是否是第一次加载
      countryCodesConfig: [],
      activeTab: '',
      loading: false,
      tabs: [],
      styleOptions: [
        { value: '1', label: '单行剧集卡片' },
        { value: '2', label: '三列瀑布流(置底)' },
      ],
      tableData: [],
      originalTableData: [],
      dialogVisible: false,
      isEdit: false,
      formData: {
        id: '',
        title: '',
        subhead: '',
        style: '1'
      },
      formRules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        style: [{ required: true, message: '请选择样式', trigger: 'change' }]
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      episodeDialogVisible: false,
      selectedTheater: null,
      mockDataMap: {
      },
      isPut: false,
      // 为每个语言tab维护独立的变更状态
      dataChangedMap: {},
    }
  },
  computed: {
    isDataChanged() {
      // 返回当前语言tab的变更状态
      return this.dataChangedMap[this.activeTab] || false
    }
  },
  mounted() {
    this.getLanguageList()
  },
  beforeRouteLeave(to, from, next) {
    // this.isDataChanged = JSON.stringify(this.tableData) !== JSON.stringify(this.originalTableData)
    if ((this.isDataChanged || this.isUpdate)&&!this.isPut) {
      this.$Modal.confirm({
        title: '提示',
        content: '您有未保存的更改，确定要离开吗？',
        onOk: () => {
          publishConfig({ state:false,countryId:this.activeTab }).then((r) => {
            if (r.code === 200) {
              next()
            }
          })
        },
        onCancel: () => {
          next(false)
          this.$nextTick(() => {
            this.$root.$emit('restoreMenuActive', from.name)
          })
        }
      })
    } else {
      next()
    }
  },
  // 监听tableData变化
  watch: {
    tableData: {
      handler(newVal, oldVal) {
        if(JSON.stringify(newVal) !==JSON.stringify(this.originalTableData)){
          // 使用 $set 确保响应式更新
          this.$set(this.dataChangedMap, this.activeTab, true)
          // 数据变化时重置发布状态，确保离开提示正常工作
          this.isPut = false
        }
      },
      deep: true
    },
    // 监听isUpdate变化，剧集列表变化时重置发布状态
    isUpdate(val) {
      if (val) {
        this.isPut = false
      }
    }
  },
  methods: {
    // 获取语言列表
    getLanguageList() {
      this.loading = true
      getLangList({ current: -1, size: -1 }).then((r) => {
        if (r.code === 200) {
          const data = r.data.records || []
          data.forEach(item => {
            item.label = item.chineseLangName||item.langName
            item.value = item.id.toString()
          })
          this.tabs = data
          this.activeTab = data[0].id.toString()
          this.loadData()
        }
      })
    },
    loadData() {
      this.loading = true
      getConfigList({ current: this.page.current, size: this.page.size, countryId: this.activeTab }).then((r) => {
        if (r.code === 200) {
          const data = r.data.records || []
          this.tableData = data
          // 每次加载数据时都保存当前语言的原始数据
          this.originalTableData = JSON.parse(JSON.stringify(this.tableData))
          this.page.total = this.tableData.length
        }
      }).finally(() => {
        this.loading = false
      })
    },

    getData() {
      this.loadData()
    },
    handleTabChange() {
      this.page.current = 1
      this.loadData()
    },
    handleSaveOrder() {
      publishConfig({ state:true,countryId:this.activeTab }).then((r) => {
        if (r.code === 200) {
          this.$Message.success('发布成功')
          this.loadData()
          this.isPut = true
          this.isUpdate = false // 发布成功后，按钮置灰禁用
          // 发布成功后重置当前语言tab的变更状态
          this.$set(this.dataChangedMap, this.activeTab, false)
        }
      })
    },
    // 处理拖动结束
    handleDragEnd(evt) {
      let arr=[]
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].state === 1) {
          arr.push({
            id: this.tableData[i].id,
            sort: i + 1
          })
        }
      }
      // 更新排序
      updateSort({ sortList: arr}).then((r) => {
        if (r.code === 200) {
          this.loadData()
        }
      })
    },
    handleAdd() {
      this.isEdit = false
      this.formData.id = ''
      this.formData.title = ''
      this.formData.subhead = ''
      this.formData.style = '1'
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.formData.id = row.id
      this.formData.title = row.title
      this.formData.subhead = row.subhead
      this.formData.style = String(row.style)
      this.dialogVisible = true
    },
    handleModifyList(row) {
      this.selectedTheater = row
      this.episodeDialogVisible = true
    },
    handleSwitchChange(row, val) {
      this.isPut = false
      row.state = val ? 1 : 0
      updateConfig(row).then(res => {
        if (res.code === 200) {
          this.$Message.success('更新成功')
          this.loadData()
          // 设置数据变更状态，确保离开提示正常工作
          this.$set(this.dataChangedMap, this.activeTab, true)
        }
      })
    },
    handleDelete(row) {
      this.isPut = false
      this.$Modal.confirm({
        title: '提示',
        content: '是否确认删除该记录？',
        onOk: () => {
          deleteConfig([row.id]).then((r) => {
            if (r.code === 200) {
              this.$Message.success('删除成功')
              this.loadData()
              this.isUpdate = true // 删除成功，发布按钮启用
            }
          })
        },
        onCancel: () => {
          this.$Message.info('已取消删除')
        }
      })
    },
    handleConfirm() {
      this.loadData()
    },
    handleCancel() {
      this.dialogVisible = false
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields()
      }
    },
    handleSave() {
      this.isPut = false
      this.$refs.formRef.validate(valid => {
        if (valid) {
          const saveData = {
            ...this.formData,
            style: Number(this.formData.style),
            countryId: Number(this.activeTab),
          }
          if (this.isEdit) {
            updateConfig(saveData).then(res=>{
              if(res.code === 200){
                this.dialogVisible = false
                this.$Message.success('编辑成功')
                this.$refs.formRef.resetFields()
                this.loadData()
                // 编辑成功后设置数据变更状态，使发布按钮变为可点击
                this.$set(this.dataChangedMap, this.activeTab, true)
              }
            })
          } else {
            if(!saveData.id){
              delete saveData.id
            }
            addConfig({ theaterConfigDTO: [saveData] }).then((r) => {
              if (r.code === 200) {
                this.$Message.success('新增成功')
                this.dialogVisible = false
                this.loadData()
                this.$refs.formRef.resetFields()
                // 新增成功后设置数据变更状态，使发布按钮变为可点击
                this.$set(this.dataChangedMap, this.activeTab, true)
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.table-container {
  background: #fff;
  border-radius: 8px;
  padding: 0;
  overflow: hidden;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border: 1px solid #ebeef5;
}

.custom-table th,
.custom-table td {
  padding: 12px 16px;
  font-size: 14px;
  border: 1px solid #ebeef5;
  text-align: left;
}

.custom-table th {
  background-color: #fafafa;
  font-weight: 600;
  color: #303133;
  border-right: 1px solid #ebeef5;
}

.custom-table th:last-child,
.custom-table td:last-child {
  border-right: none;
}

.custom-table tr:hover {
  background-color: #fafafa;
}

.col-drag {
  width: 60px;
  text-align: center;
}

.col-title {
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.col-subtitle {
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.col-style {
  width: 140px;
}

.col-count {
  width: 100px;
}

.col-enabled {
  width: 80px;
  text-align: center;
}

.col-action {
  width: 220px;
}
.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
}
.loading-spinner {
    width: 36px;
    height: 36px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #409eff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
:deep(.sortable-ghost) {
  background-color: #e6f7ff !important;
  opacity: 0.8;
}
.no-data {
  width: 100%;
  height: 48px;
  text-align: center;
  padding: 20px 0;
  color: #515a6e;
}
</style>
